export default function Node_RESTAPI() {
  return <div>Node_RESTAPI Component</div>;
}
